import React from 'react';
import { HashRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import Contact from './components/Contact';
import AboutUs from './components/AboutUs';
import AppInterface from './components/AppInterface';
import PrivacyPolicy from './components/PrivacyPolicy';
import HRDashboard from './components/HRDashboard';

// Remove purepathgraph import and keep only the images you're using
import leoriise from './images/leoriise.png';
import lookingatphone from './images/lookingatphone.jpeg';
import pths from './images/pths.jpg';

function ProtectedRoute({ children }) {
  const isAuthenticated = localStorage.getItem('userToken');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  console.log('Protected Route Check:', { isAuthenticated, user });

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to home');
    return <Navigate to="/" replace />;
  }

  // Tillat tilgang basert på brukertype
  if (user.isHR) {
    console.log('HR user detected, showing HR dashboard');
    return children;
  }

  if (user.isAppUser) {
    console.log('App user detected, showing app interface');
    return children;
  }

  if (user.isAdmin) {
    console.log('Admin user detected, showing admin dashboard');
    return children;
  }

  // Standard fallback
  console.log('No matching user type, redirecting to home');
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <div className="home-page">
              <header className="hero-section">
                <h1>Dedicated to Enhancing Workplaces</h1>
                <p className="hero-subtitle">
                  Our AI-powered solutions support businesses of all sizes in creating environments 
                  that prioritize employee well-being and engagement.
                </p>
                <Link to="/about" className="about-button">About Us</Link>
                <div className="hero-image">
                  <img src={pths} alt="Pure Paths Solutions" />
                </div>
              </header>

              <section className="features-grid">
                <div className="feature-card">
                  <span className="feature-icon">💡</span>
                  <h3>Employee Engagement</h3>
                  <p>Transform your workplace with our AI-driven solutions that enhance employee satisfaction and well-being.</p>
                </div>
                <div className="feature-card">
                  <span className="feature-icon">🤝</span>
                  <h3>Continuous Support</h3>
                  <p>Benefit from ongoing AI support that adapts to your team's needs and fosters a positive work environment.</p>
                </div>
                <div className="feature-card">
                  <span className="feature-icon">📱</span>
                  <h3>Innovative App Access</h3>
                  <p>Our app enables employees to document weekly reflections, fostering connection and motivation in real-time.</p>
                </div>
                <div className="feature-card">
                  <span className="feature-icon">🎯</span>
                  <h3>Personalized Consulting</h3>
                  <p>Receive tailored advice to integrate our solutions effectively and improve your workplace dynamics imeditly.</p>
                </div>
                <div className="feature-card">
                  <span className="feature-icon">📊</span>
                  <h3>Get Live Reports</h3>
                  <p>We have gathered all the information from the employees so we can create super detailed reports, so owners can get live insights and take immediate action!</p>
                </div>
                <div className="feature-card">
                  <span className="feature-icon">🔄</span>
                  <h3>Compatible with any organization</h3>
                  <p>Big or small, our app is designed to work seamlessly with organizations of all sizes. Contact us to discuss your organization, and we'll offer you a customized deal!</p>
                </div>
              </section>

              <section className="app-preview">
                <div className="app-content">
                  <h2>Pure Paths App</h2>
                  <ul>
                    <li>Reflect on your work experiences.</li>
                    <li>Get solutions to your problems immediately.</li>
                    <li>Discover a new way to enhance your work life.</li>
                  </ul>
                </div>
                <div className="app-image">
                  <img src={lookingatphone} alt="Pure Paths App Preview" />
                </div>
              </section>

              <section className="testimonial">
                <div className="testimonial-content">
                  <blockquote>
                    "Pure Paths will save thousands of turnovers and unlock insights we never thought were possible"
                  </blockquote>
                  <div className="testimonial-author-large">
                    <img 
                      src={leoriise} 
                      alt="Leo Riise Aasheim" 
                      className="author-image-large" 
                    />
                    <div className="author-details">
                      <h4>Leo Riise Aasheim</h4>
                      <p>Founder and CEO</p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="cta-section">
                <h2>Join Leading Enterprises in Enhancing Workplace Satisfaction</h2>
                <p>Contact Us to Discover How Pure Paths Can Transform Your Organization</p>
                <Link to="/contact" className="cta-button">Contact Us</Link>
              </section>

              <footer className="site-footer">
                <div className="footer-content">
                  <div className="footer-brand">
                    <h3>Pure Paths</h3>
                    <p>AI-driven solutions that enhance workplace well-being by fostering employee engagement 
                       and addressing concerns, helping companies create a more positive and productive work environment</p>
                  </div>
                  <div className="footer-links">
                    <h4>Quick Links</h4>
                    <ul>
                      <li><Link to="/privacy">Privacy</Link></li>
                      <li><Link to="/contact">Contact Us</Link></li>
                    </ul>
                  </div>
                  <div className="footer-social">
                    <h4>Social</h4>
                    <ul>
                      <li>Facebook</li>
                      <li>Instagram</li>
                      <li>Twitter/X</li>
                    </ul>
                  </div>
                </div>
              </footer>
            </div>
          } />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/app-interface" element={
            <ProtectedRoute>
              <AppInterface />
            </ProtectedRoute>
          } />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route 
            path="/hr-dashboard" 
            element={
              <ProtectedRoute>
                <HRDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;